import { useQuery } from '@tanstack/react-query';
import {
  DuplicateCandidatesResponseSchema,
  type DuplicateCandidatesRequest,
  type DuplicateCandidatesResponse
} from '@bliks-io/contracts';
import { apiClient } from '../client';
import { entitySuggestionKeys } from '../query-keys';

export function useDuplicateCandidates(
  body: DuplicateCandidatesRequest | null,
  options?: { excludeSuggestionId?: string }
) {
  const enabled = !!body && body.payload.name.trim().length >= 3;
  const payload = body?.payload as
    | { name?: string; category?: string; department?: string }
    | undefined;
  return useQuery({
    queryKey: entitySuggestionKeys.duplicateCandidates({
      kind: body?.kind,
      name: payload?.name,
      category: payload?.category,
      department: payload?.department,
      excludeSuggestionId: options?.excludeSuggestionId
    }),
    enabled,
    staleTime: 30_000,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const { data } = await apiClient.post<DuplicateCandidatesResponse>(
        '/api/v2/entity-suggestion/duplicate-candidates',
        body
      );
      return DuplicateCandidatesResponseSchema.parse(data).data;
    }
  });
}
